import { Component, Input } from '@angular/core';
import { ProfessionalRolBaseComponent } from '../user-roles/user-roles.base.component';

@Component({
  selector: 'app-role-doctor',
  templateUrl: './role-doctor.component.html',
  styleUrls: ['./role-doctor.component.scss'],
})
export class RoleDoctorComponent extends ProfessionalRolBaseComponent {
  @Input({ required: true }) public education: string;
}
